<template>
<div class="pur-goods-info">
  <GoodsInfo></GoodsInfo>
</div>
</template>

<script>
export default {
    data(){
        return{
            
        }
    },
    methods:{

    },
    created(){

    },
    props:{
        
    }
}
</script>

<style lang="scss">
.pur-goods-info{
    
}
</style>